export const environment = {
    production: '${IS_PRODUCTION}',
    backendURI: '${REPORTING_BACKEND_URI}',
    portalBackendURI: '${PORTAL_BACKEND_URI}',
    dmURI: '${DM_URI}',
    portalUiURI: '${PORTAL_UI_URI}',
    baseURI: '${BASE_URI}',
    powerBIURI: '${POWER_BI_URI}',
    emailNotifierURI: '${EMAIL_NOTIFIER_URI}',
    logViewerURI: '${LOG_VIEWER_URI}',
    envName: '${ENV_NAME}',
    version: '${BUILD_TAG_UI}',
    rowLimit: '${AG_GRID_ROW_LIMIT}',
};
